/* eslint-disable no-nested-ternary */
/* eslint-disable dot-notation */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, TabContent, TabPane } from 'reactstrap';

import { BID_STATUS, BIDDING_ORDER_STATUS } from 'utils/constants';
import { DEMANDS_QUERY, OFFERS_QUERY } from 'utils/CommonGraphQL';
import client from 'config/apollo';
import CardWithTitle from 'components/CardWithTitle';
import ErrorBoundary from 'components/common/ErrorBoundary';
import CustomTabs from 'components/CustomTabs';
import FavouritedUsersDetail from 'pages/MarketListing/components/FavouritedUsersDetail';
import Bids from './components/Bids';
import Summary from './components/Summary';

const BiddingDetails = ({ id, bidType }) => {
  const { selectedBid } = useSelector((state) => state.bidDetailsReducer);

  const [activeTab, setActiveTab] = useState(BIDDING_ORDER_STATUS.ACTIVE_BIDS);
  const data =
    bidType === 'offer'
      ? client.readQuery({
          query: OFFERS_QUERY,
          variables: {
            ...selectedBid?.filters,
          },
        })
      : client.readQuery({
          query: DEMANDS_QUERY,
          variables: {
            ...selectedBid?.filters,
          },
        });

  const rowInd =
    bidType === 'offer'
      ? data?.offers?.offers.findIndex((val) => val.id === id)
      : data?.demands?.demands.findIndex((val) => val.id === id);

  const buttonDisabled = false;
  const [rowIndex, setRowIndex] = useState(rowInd);
  const currentRow =
    bidType === 'offer'
      ? data?.offers?.offers[rowIndex]
      : data?.demands?.demands[rowIndex];
  const gradeId = currentRow?.grade?.id || currentRow?.grades?.[0]?.id;

  const handlePrevNext = (e, step) => {
    if (step === 'next') {
      setRowIndex(rowIndex + 1);
    } else {
      setRowIndex(rowIndex - 1);
    }
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      <CardWithTitle title="">
        <Row>
          {currentRow && (
            <Summary
              {...currentRow}
              index={rowIndex}
              handlePrevNext={handlePrevNext}
              max={
                bidType === 'offer'
                  ? data?.offers?.offers.length
                  : data?.demands?.demands.length
              }
              buttonDisabled={!buttonDisabled}
              bidType={bidType}
            />
          )}
        </Row>
      </CardWithTitle>
      {currentRow && <FavouritedUsersDetail gradeId={gradeId} />}
      <CardWithTitle title="" className="pb-3">
        <div className="d-flex align-items-center">
          <CustomTabs
            tabs={[
              BIDDING_ORDER_STATUS.ACTIVE_BIDS,
              BIDDING_ORDER_STATUS.EXPIRED_BIDS,
              BIDDING_ORDER_STATUS.ACCEPTED_BIDS,
              BIDDING_ORDER_STATUS.REJECTED_BIDS,
              BIDDING_ORDER_STATUS.WITHDRAWN_BIDS,
            ]}
            selectedTab={activeTab}
            onTabChange={toggle}
            className="mb-1"
          />
        </div>

        <TabContent activeTab={activeTab}>
          <TabPane tabId={BIDDING_ORDER_STATUS.ACTIVE_BIDS}>
            {activeTab === BIDDING_ORDER_STATUS.ACTIVE_BIDS && (
              <ErrorBoundary>
                <Bids
                  id={currentRow?.id}
                  status={BID_STATUS.IN_PROGRESS}
                  bidType={bidType}
                />
              </ErrorBoundary>
            )}
          </TabPane>

          <TabPane tabId={BIDDING_ORDER_STATUS.EXPIRED_BIDS}>
            {activeTab === BIDDING_ORDER_STATUS.EXPIRED_BIDS && (
              <ErrorBoundary>
                <Bids
                  id={currentRow?.id}
                  status={BID_STATUS.EXPIRED}
                  bidType={bidType}
                />
              </ErrorBoundary>
            )}
          </TabPane>

          <TabPane tabId={BIDDING_ORDER_STATUS.ACCEPTED_BIDS}>
            {activeTab === BIDDING_ORDER_STATUS.ACCEPTED_BIDS && (
              <ErrorBoundary>
                <Bids
                  id={currentRow?.id}
                  status={BID_STATUS.ACCEPTED}
                  bidType={bidType}
                />
              </ErrorBoundary>
            )}
          </TabPane>
          <TabPane tabId={BIDDING_ORDER_STATUS.REJECTED_BIDS}>
            {activeTab === BIDDING_ORDER_STATUS.REJECTED_BIDS && (
              <ErrorBoundary>
                <Bids
                  id={currentRow?.id}
                  status={BID_STATUS.REJECTED}
                  bidType={bidType}
                />
              </ErrorBoundary>
            )}
          </TabPane>
          <TabPane tabId={BIDDING_ORDER_STATUS.WITHDRAWN_BIDS}>
            {activeTab === BIDDING_ORDER_STATUS.WITHDRAWN_BIDS && (
              <ErrorBoundary>
                <Bids
                  id={currentRow?.id}
                  status={BID_STATUS.WITHDRAWN}
                  bidType={bidType}
                />
              </ErrorBoundary>
            )}
          </TabPane>
        </TabContent>
      </CardWithTitle>
    </div>
  );
};

export default BiddingDetails;
